<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-hidden" >
      <div slot="no-body">
        <div class="vx-card__header">
          <div class="vx-card__title">
            <h4>{{ $t(i18n) || title }}</h4>
          </div>
          <div class="vx-card__actions">
            <div class="vx-card__action-buttons">
              <feather-icon v-if="enableZoomIn" @click="zoomIn" icon="SearchIcon" svgClasses="h-6 w-6" class="ml-4" />
              <feather-icon v-if="enableDrilling" @click="drillTo" icon="CornerRightDownIcon" svgClasses="h-6 w-6" class="ml-4"/>
            </div>
          </div>
        </div>
        <div>
          <vue-apex-charts  type="bar" height="266" :options="chartOptions" :series="chartData" />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import shared from '@/filters/shared.js'

export default {
  props: {
    title: {
      type: String
    },
    i18n : {
      type: String
    },
    linkTo: {
      type: String
    },
    enableZoomIn: {
      type: Boolean,
      default: false
    },
    categories : {

    },
    chartData: {
      // type: Array,
      // required: true
    },
    yAxisTitle: {
      type: String
    },
    yAxisTitlei18n: {
      type: String
    }
  },
  
  computed : {
    formattedLeftData() {
      return shared.formatValue(this.leftDataValue, this.dataFilter, this);
    },
    formattedRightData() {
      return shared.formatValue(this.rightDataValue, this.dataFilter, this);
    },
    enableDrilling() {
      return this.linkTo !== "" && typeof this.linkTo !== 'undefined';
    }
  },
  data () {
    return {
      chartOptions: null
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    this.chartOptions = Object.assign({}, chartConfigs.columnChart)
    
    if (this.$props.categories) {
      if (this.chartOptions.xaxis) {
        this.chartOptions.xaxis.categories = this.$props.categories
      } else {
        this.chartOptions.xaxis = {
          categories : this.$props.categories
        }
      }
    }

    if (this.$props.yAxisTitle) {
      if (!this.chartOptions.yaxis) {
        this.chartOptions.yaxis = {
          title : {
            text: this.$props.yAxisTitle
          }
        }
      }
    }
  },
  methods: {
    zoomIn() {
      this.$emit("onZoomIn");
    },
    drillTo() {
      this.$emit("onDrillTo", this.linkTo);
    }
  }
}
</script>
